import React, { useState, Suspense } from 'react';
import { Tabs, Tab, withStyles, Box } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { connect } from 'react-redux';
import CircularProgress from '@material-ui/core/CircularProgress';
import { hasPermission } from '../../sc-utilities';

import WorkDiagnoseReport from '../../sc-diagnose/WorkDiagnoseReport';
import ReportList from './ErasureReport';

const styles = theme => ({
    root: {
        width: `98.9%`,
        height: 'auto',
        paddingLeft: theme.spacing(),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    },
    rootPaper: {
        width: 'auto',
        height: 'auto',
        padding: '21px',

        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        },
    },
});

const TabContainer = props => {
    return (
        <Typography component="div" dir={props.dir} style={{ paddingTop: 3 * 3 }}>
            {props.children}
        </Typography>
    );
};
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index || props.disabled}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3} style={{ padding: '0px' }} disabled={true}>
                    {children}
                </Box>
            )}
        </div>
    );
}

const Report = props => {
    const { classes, theme, translations, productID, onGenerate, isSingleTab } = props;
    const [tabValue, setTabValue] = useState(0);

    const handleChange = (event, value) => {
        setTabValue(value);
    };
    return <div className={classes.root} >
      {isSingleTab ? null : <Tabs
            value={tabValue}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
        >
            {hasPermission(props.permissions, 'erasure_report_list') && <Tab label={translations["erasure_report"] || "Erasure report"} index={0} />}
            {hasPermission(props.permissions, 'diagnose_report_list') && <Tab label={translations["work_diagnose_report"] || "Diagnose report"} index={1} />}
            {hasPermission(props.permissions, 'verification_report_list') && <Tab label={translations["verification_report"] || "Verification report"} index={2} />}
            {hasPermission(props.permissions, 'asset_check_report_list') && <Tab label={translations["asset_check_report"] || "Asset check report"} index={3} />}
        </Tabs>
}
        {hasPermission(props.permissions, 'erasure_report_list') && <TabPanel index={0} value={tabValue}> <TabContainer dir={theme.direction}><Suspense fallback={<div><CircularProgress /></div>}><ReportList productID={productID} tabValue={tabValue} onGenerate={onGenerate} isSingleTab={isSingleTab} erasureReportType={'pdf'} /></Suspense></TabContainer> </TabPanel>}
        {!isSingleTab ? hasPermission(props.permissions, 'diagnose_report_list') && <TabPanel index={1} value={tabValue}> <TabContainer dir={theme.direction}><Suspense fallback={<div><CircularProgress /></div>}><WorkDiagnoseReport productID={productID} tabValue={tabValue} onGenerate={onGenerate} /></Suspense></TabContainer> </TabPanel> : null}
        {!isSingleTab ? hasPermission(props.permissions, 'verification_report_list') && <TabPanel index={2} value={tabValue}> <TabContainer dir={theme.direction}><Suspense fallback={<div><CircularProgress /></div>}><ReportList productID={productID} tabValue={tabValue} onGenerate={onGenerate} erasureReportType={'verification-pdf'} /></Suspense></TabContainer> </TabPanel> : null}
        {!isSingleTab ? hasPermission(props.permissions, 'asset_check_report_list') && <TabPanel index={3} value={tabValue}> <TabContainer dir={theme.direction}><Suspense fallback={<div><CircularProgress /></div>}><ReportList productID={productID} tabValue={tabValue} onGenerate={onGenerate} erasureReportType={'check-pdf'} /></Suspense></TabContainer> </TabPanel> : null}
    </div>
}

const mapStateToProps = state => {
    return {
        permissions: state?.core?.login?.permissions || [],
        translations: state?.translate?.translations?.activeTranslations || {},
    };
};


const mapDispatchToProps = dispatch => {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(Report));